export default "__VITE_ASSET__BcdNbJTR__"